import React from "react";
import facilitiesCover from "../../../Assets/Hompage/facilities/facilities.jpeg";
import facilitiesCoverMobile from "../../../Assets/Hompage/Banner/Home page-05.jpg";
import medical from "../../../Assets/Hompage/facilities/service.jpeg";
import parking from "../../../Assets/Hompage/facilities/parking.jpeg";
import ball from "../../../Assets/Hompage/facilities/ball.jpeg";
import restaurant from "../../../Assets/Hompage/Restaurant/Restaurant (4).jpeg";
import swimming from "../../../Assets/Hompage/Swimming/Swimming1 (2).jpeg";
import playGround from "../../../Assets/Hompage/playGround/playGround (3).jpg";
const Facilities = () => {
  return (
    <div className="bg-gray-100">
      <div className="pt-16 md:pt-0 md:block hidden">
        <img src={facilitiesCover} alt="Facilities" className="w-full" />
      </div>
      <div className="pt-16 md:pt-0 md:hidden block">
        <img src={facilitiesCoverMobile} alt="Facilities" className="w-full" />
      </div>
      <section className="py-32 max-w-screen-xl mx-auto md:px-0 px-5">
        <div className="flex md:justify-start justify-center ">
          <div className="">
            <div className="nahid-title-designer mb-32">
              <h1
                data-aos="zoom-in"
                className="text-[40px] md:text-[40px] font-bold tracking-wide "
              >
                Facilities
              </h1>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10 xl:gap-20 ">
          <div className="flex items-center">
            <div>
              <h1 className="text-center text-[35px] font-bold tracking-wide ">
                Emergency Medical Service
              </h1>
              <p className="my-10 leading-7 text-center">
                These parking areas are usually located on the premises of the
                resort or hotel and are designed to provide convenient and
                secure parking for guests. The parking may be outdoor or indoor
                and may be free or require payment. Resort car parking may be
                available for both overnight guests and day visitors.
              </p>
            </div>
          </div>
          <div>
            <img src={medical} alt="Medical" className="" data-aos="zoom-in" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10 xl:gap-20 py-32 ">
          <div className="md:order-first order-last">
            <img src={parking} alt="Parking" className="" data-aos="zoom-in" />
          </div>
          <div className="flex items-center ">
            <div>
              <h1 className="text-center text-[35px] font-bold tracking-wide ">
                Car Parking
              </h1>
              <p className="my-10 leading-7 text-center">
                These parking areas are usually located on the premises of the
                resort or hotel and are designed to provide convenient and
                secure parking for guests. The parking may be outdoor or indoor
                and may be free or require payment. Resort car parking may be
                available for both overnight guests and day visitors.
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10 xl:gap-20 py-32">
          <div className="flex items-center">
            <div>
              <h1 className="text-center text-[35px] font-bold tracking-wide ">
                Conference & Ball room
              </h1>
              <p className="my-10 leading-7 text-center">
                Matir Maya Eco Resort is the ideal venue for Board meetings,
                Conference, Seminars, Workshops, Trainings, Parties, Cultural
                Programs and Executive retreats. We provide top notch technical
                support including MMP, projection screen, sound system with
                collar and wireless microphone for any kind of programs in
                conference room. Our highly experienced professionals are
                dedicated to meet your requirements and make your events
                successful.
              </p>
            </div>
          </div>
          <div>
            <img src={ball} alt="conference" className="" data-aos="zoom-in" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10 xl:gap-20 py-32">
          <div className="md:order-first order-last">
            <img
              src={restaurant}
              alt="Restaurant"
              className=""
              data-aos="zoom-in"
            />
          </div>
          <div className="flex items-center">
            <div>
              <h1 className="text-center text-[35px] font-bold tracking-wide ">
                Restaurant
              </h1>
              <p className="my-10 leading-7 text-center">
                We have large exotic food outlets to provide top level services
                to our clients. Our multi cuisine restaurant offers a wide range
                of Bengali, Indian, Thai, Chinese and Continental dishes. Our
                menus are bursting with unique and savory experiences that
                change with seasons. In one sitting we can provide services to
                100 people.
              </p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10 xl:gap-20 py-32">
          <div className="flex items-center">
            <div>
              <h1 className="text-center text-[35px] font-bold tracking-wide ">
                Swimming Pool
              </h1>
              <p className="my-10 leading-7 text-center">
                Our resort is designed to provide a luxurious and relaxing
                experience for all our guests. Here, you can enjoy not one, but
                two stunning swimming pools! For the adults, we have a spacious
                crystal clear swimming pool that is perfect for taking a
                refreshing dip on a hot day. You can take a swim anytime here
                that provides the perfect atmosphere for relaxation. For our
                younger guests, we have a separate swimming pool just for kids.
                The pool is designed with their safety in mind, and the water is
                shallow enough for children to play in with ease. The pool is
                also well-maintained and cleaned regularly to ensure a hygienic
                environment for your little ones.
              </p>
            </div>
          </div>
          <div>
            <img
              src={swimming}
              alt="Swimming"
              className=""
              data-aos="zoom-in"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-10 xl:gap-20 py-32">
          <div className="md:order-first order-last">
            <img
              src={playGround}
              alt="Playground"
              className=""
              data-aos="zoom-in"
            />
          </div>
          <div className="flex items-center">
            <div>
              <h1 className="text-center text-[35px] font-bold tracking-wide ">
                Play Ground
              </h1>
              <p className="my-10 leading-7 text-center">
                In our exciting play zone, where kids can let loose, play, and
                have fun! Our play zone features a variety of different play
                equipment like a spacious and well-maintained ground that
                provides the perfect space for kids to run around and play. This
                open space is the ideal spot for kids to burn off some energy
                and get moving. Next, we have a classic swing that is sure to
                bring a smile to any child's face, and is secured firmly in the
                ground to provide a stable and secure play experience. With our
                range of play equipment and safe, well-maintained environment,
                you can be sure that your kids will have a blast while staying
                safe and secure.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Facilities;
